import { render, staticRenderFns } from "./Deleted.vue?vue&type=template&id=5bfcdd12&scoped=true"
import script from "./Deleted.vue?vue&type=script&lang=js"
export * from "./Deleted.vue?vue&type=script&lang=js"
import style0 from "./Deleted.vue?vue&type=style&index=0&id=5bfcdd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfcdd12",
  null
  
)

export default component.exports